import { jsx as i } from "react/jsx-runtime";
import d from "clsx";
import { forwardRef as g } from "react";
import o from "./Popover.module.css.js";
const b = (t) => ({
  [o.top]: t === "top" || t === "top-start" || t === "top-end",
  [o.bottom]: t === "bottom" || t === "bottom-start" || t === "bottom-end",
  [o.left]: t === "left" || t === "left-start" || t === "left-end",
  [o.right]: t === "right" || t === "right-start" || t === "right-end"
}), h = g(
  ({ placement: t, className: r, ...s }, f) => /* @__PURE__ */ i(
    "div",
    {
      ref: f,
      className: d(o.arrow, r, b(t)),
      ...s
    }
  )
);
h.displayName = "DefaultArrow";
export {
  h as DefaultArrow
};
//# sourceMappingURL=DefaultArrow.js.map
